import * as React from 'react'
import {
  Column,
  Text,
  Row,
  Layout,
  Icon,
  DotDivider,
  styleguide,
} from 'styleguide'
import Scoops from 'api'
import * as Illustrations from '../Illustrations'
import mixpanel from 'mixpanel-browser'
import { css } from 'react-emotion'
const scoops = Scoops('scoops-api-key', mixpanel)
function survey() {
  scoops.survey('mount', 'mount', { offset: true, cycle: true }).then(survey)
}
export default function({ className }) {
  setTimeout(() => {
    survey()
  }, 100)
  return (
    <Layout size="medium">
      <Row
        justify="space-between"
        align="center"
        break="reverse"
        css={`
          z-index: 3;
        `}>
        <Row
          justify="start"
          align="end"
          css={`
            height: 400px;
            margin-right: 40px;
            ${styleguide.mobile(
              css`
                margin-right: 0;
                margin-bottom: 40px;
              `
            )};
          `}>
          <div id="mount" />
        </Row>
        <Row
          align="start"
          break
          css={`
            min-width: 50%;
          `}>
          <Icon
            icon="heart"
            primary
            css={`
              margin-right: 20px;
              margin-top: 3px;
              ${styleguide.mobile(css`
                margin-bottom: 20px;
              `)};
            `}
          />
          <Column>
            <Text subtitle bold serif primary>
              Keep Your Users Happy
            </Text>
            <DotDivider />
            <Text subtext pt>
              Ask as many questions as you want! We’ll make sure your users
              never get spammed <b>and</b> make sure you get the answers you
              need.
            </Text>
            <br />
            <Text subtext pt>
              Scoops blends into your site, and makes answering questions feel
              goooood.
            </Text>
          </Column>
        </Row>
      </Row>
      <div
        css={`
          position: absolute;
          width: 100%;
          height: 100%;
        `}>
        <Illustrations.ChevronCircle
          color="illustrationOrange"
          css={`
            position: absolute;
            left: -140px;
            bottom: 240px;
            width: 200px;
            height: 200px;
            z-index: 1;
          `}
        />
        <Illustrations.PokadotCircle
          color="secondary"
          css={`
            position: absolute;
            left: -80px;
            bottom: 40px;
            width: 400px;
            height: 400px;
            z-index: 2;
          `}
        />
      </div>
    </Layout>
  )
}



// WEBPACK FOOTER //
// ./src/components/Sections/KeepYourUsersHappy.jsx